<template>
  <div id="grid-candidatos">
    <v-layout>
      <v-flex xs4>
        <v-btn color="primary" @click="descargaAsignacion()"
          >Descarga Plantilla Edición</v-btn
        >
      </v-flex>
      <v-flex xs4 grid-list-xl>
        <v-toolbar-title class="indigo--text"
          >Carga masiva Edición</v-toolbar-title
        >
        <data-adjunto
          :documentoId="id"
          :tipeView="tipeView"
          :tipeArchive="tipeArchive"
        ></data-adjunto>
      </v-flex>
      <v-flex xs1>
        <v-btn
          v-if="botonCargar == true"
          depressed
          :loading="loading1"
          outline
          icon
          fab
          dark
          color="primary"
          medium
          title="Cargar planilla"
          @click="validarArchivo()"
        >
          Validar
        </v-btn>
      </v-flex>
      <v-flex xs3>
        <v-btn
          v-if="botonProcesar == true"
          color="primary"
          :loading="loading1"
          dark
          class="mb-2"
          @click="procesarCarga()"
        >
          Cargar
        </v-btn>
      </v-flex>
    </v-layout>

    <v-container grid-list-xl fluid>
      <v-layout class="d-flex pa-2">
        <div class="d-flex pa-2" xs12 sm6>
          <v-text-field
            width="300px"
            v-model="txtBusqueda"
            placeholder="Ingresa el nombre o código para la busqueda por palabra clave"
            single-line
          ></v-text-field>
          <v-btn
            color="primary"
            @click="loadData()"
            :disabled="txtBusqueda.length < 3"
            class="shrink"
            ><v-icon dark left>search</v-icon>Buscar</v-btn
          >
          <v-btn
            color="secondary"
            @click="limpiaBuscador()"
            :disabled="txtBusqueda.length < 3"
            class="shrink"
            ><v-icon dark left>backspace</v-icon>Limpiar</v-btn
          >
        </div>
      </v-layout>

      <v-layout justify-center>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-data-table
            :headers="headers"
            :items="itemsDocumento"
            hide-actions
            :pagination.sync="miPaginacion"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.rut + "-" + props.item.dv }}</td>
              <td class="text-xs-left">{{ props.item.nombre }}</td>
              <td class="text-xs-left">
                {{ props.item.region != null ? props.item.region.nombre : "-" }}
              </td>
              <td>
                {{ props.item.comuna != null ? props.item.comuna.nombre : "-" }}
              </td>
              <td class="cargo">{{ props.item.rolCapId.descripcion }}</td>
              <td class="text-xs-left">{{ props.item.estado }}</td>
              <td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Ver reclutado"
                  @click="viewAsignacion(props.item.id)"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    usuarioLoggedTipe == 'PROVEEDOR' ||
                    usuarioLoggedTipe == 'ADMINISTRADOR'
                  "
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Asignacion a centros"
                  @click="editAsignacion(props.item.id)"
                >
                  <v-icon>open_in_new</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>remove_red_eye</v-icon> </v-btn
            >&nbsp;Ver reclutados
            <v-btn
              v-if="
                usuarioLoggedTipe == 'PROVEEDOR' ||
                usuarioLoggedTipe == 'ADMINISTRADOR'
              "
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="blue darken-4"
              small
            >
              <v-icon>open_in_new</v-icon> </v-btn
            >&nbsp;Asignacion a centros
          </v-card-actions>
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="itemsDocumento.length"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          v-if="botonDescarga == true"
          color="primary"
          @click="descargaMasiva()"
          >Descarga</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-dialog v-model="dialogArchivo" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">Resumen de Archivo </v-card-title>
          <v-card-text>
            <v-flex lg12>
              <v-spacer></v-spacer>
              <v-card-actions class="pb-3">
                <v-spacer></v-spacer>
              </v-card-actions>

              <p v-if="respOk == false">{{ this.resp }}</p>
              <div class="text-resp" v-if="respOk == true">
                <v-icon class="ico-resp">check_circle</v-icon>
                <p>Archivo sin errores!</p>
              </div>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeModal()"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import DataAdjunto from "@/components/AdjuntoData.vue";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-asignacion",

  components: {
    Loading,
    AlertEmpty,
    LoadingDescarga,
    DataAdjunto,
  },
  props: {
    rowsTable: "",
    tipeView: "",
  },

  data() {
    return {
      txtBusqueda: "",
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      dialogLoading: false,
      botonProcesar: false,
      botonCargar: true,
      loading: false,
      loading1: false,
      alerta: false,
      respOk: false,
      botonDescarga: false,
      dialogArchivo: false,
      rutCandidatoValue: null,
      rutCandidatoSelect: [],
      resp: "",
      id: "",
      pagination: {
        rowsPerPage: 20,
      },
      idContrato: "",
      headers: [
        { text: "Rut Candidato", align: "left", sortable: false, value: "rut" },
        { text: "Candidato/a", sortable: false, value: "nombre" },
        { text: "Region", sortable: false, value: "region" },
        { text: "Comuna", sortable: false, value: "comuna" },
        { text: "Cargo", sortable: false, value: "cargo" },
        { text: "Estado", sortable: false, value: "estado" },
        {
          text: "Acciones para asiganación",
          sortable: false,
          value: "",
        },
      ],
      usuarioLoggedTipe: "",
      bloqueo: Boolean,
      itemsDocumento: [],
      idUserLogged: "",
      proceso: "",
      estadoValue: null,
      tipeArchive: "",
      btnHidden: false,
      tab: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 5000);
    },
  },
  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.tipeArchive = ".pdf,.doc,.jpg,.png,.xlsx";
    this.loadData();
  },

  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    descargaAsignacion() {
      this.dialogLoading = true;
      axios
        .get("/candidatos/downloadPlanillaAsignacion/" + this.idContrato, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "PLANILLA_ASIGNACION.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async loadAsignacionFilter() {
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        txtBusqueda: this.txtBusqueda,
        origenBusqueda: this.tab,
      };
      return await axios
        .post("/candidatos/asignacion/filter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsDocumento = await this.loadAsignacionFilter();
      this.miPaginacion.totalItems = this.itemsDocumento.length;

      if (this.itemsDocumento.length > 0) {
        this.alerta = false;
        this.botonDescarga = true;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },

    respIsEmpty(mapArchivo) {
      for (var key in mapArchivo) {
        if (mapArchivo.hasOwnProperty(key)) return false;
      }
      return true;
    },
    closeModal() {
      this.dialogArchivo = false;
      let resp = this.resp;
      if (resp) {
        this.botonProcesar = true;
        this.botonCargar = false;
      } else {
        this.botonProcesar = false;
        this.botonCargar = true;
      }
    },
    async validarArchivo() {
      this.loading1 = true;
      this.resp = await this.preProcessFile();
      let respuesta = this.resp;
      console.log(respuesta);
      if (respuesta == undefined) {
        console.log(respuesta);
      } else {
        let resp = this.resp;
        if (resp) {
          this.respOk = true;
        } else {
          this.rutNoValid = respuesta;
        }
        this.dialogArchivo = true;
      }

      this.loading1 = false;
    },
    async preProcessFile() {
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        documento: base64EncodedStr,
        idContrato: idContrato,
      };
      return await axios
        .post("/candidatos/asignacion/preProcessFile", this.body)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
        });
    },
    async procesarCarga() {
      this.loading1 = true;
      this.resp = await this.procesarArchivo();
      this.loading1 = false;
    },
    procesarArchivo() {
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        documento: base64EncodedStr,
        idContrato: idContrato,
      };
      axios
        .post("/candidatos/asignacion/file", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.reload();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.reload();
          }
        });
    },
    editAsignacion(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "CandidatosRegistra",
          params: { id: id, tipeView: "modifica" },
        });
      }, 1000);
    },
    viewAsignacion(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "CandidatosRegistra",
          params: { id: id, tipeView: "consulta" },
        });
      }, 1000);
    },
    descargaMasiva() {
      this.dialogLoading = true;
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        txtBusqueda: this.txtBusqueda,
        origenBusqueda: this.tab,
      };
      axios
        .post("/candidatos/downloadExcel/asignacion", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "DESCARGA_ASIGNACION.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    reload() {
      setTimeout(() => {
        this.$parent.$parent.reloadDocumento();
      }, 1000);
    },
    limpiaBuscador() {
      this.txtBusqueda = "";
      this.loadData();
    },
    filterAsig() {
      this.loadData();
    },
  },
};
</script>
